import AppManifest from '../common/AppManifest';
// import { crashlyticsLog } from '../common/crashlytics';

export function log(...args: any[]) {
  const message: string = args.join(' ');
  if (AppManifest.env === 'production') {
    console.log(message);
    // crashlyticsLog(message);
  } else {
    console.log(message);
  }
}
